// extracted by mini-css-extract-plugin
export default {"container":"FeedbackCheckbox_container__k50tE","paddingBottom":"FeedbackCheckbox_paddingBottom__Xmhn0"};